import { Outlet } from "react-router";

export function CustomerHtzRoute() {
  return <Outlet />;
}
